import { Injectable, inject } from '@angular/core';
import { DictionaryPhoneNumberApiService } from '../api/services/dictionary-phone-number-api.service';
import { map, Observable } from 'rxjs';
import { SelectItem } from '@web/shared/ui';
import { CollectionRequestBuilder } from '@web/common';

@Injectable({
  providedIn: 'root',
})
export class DictionaryPhoneCountryPrefixSelectItemsProviderService {
  private readonly dictionaryApi = inject(DictionaryPhoneNumberApiService);
  private readonly collectionRequestBuilder = inject(CollectionRequestBuilder);

  public selectItems(): Observable<SelectItem<string>[]> {
    return this.dictionaryApi
      .fetchCollection({
        request: this.collectionRequestBuilder
          .page(1)
          .disablePagination()
          .build(),
        cacheable: true,
        skipByLoading: true,
      })
      .pipe(
        map((response) =>
          response.items.map(
            (item) => new SelectItem(`${item.prefix}`, item.prefix),
          ),
        ),
      );
  }

  public fetchDefaultSelectItem(): Observable<SelectItem<string>> {
    return this.selectItems().pipe(
      map((items) => {
        const [first] = items;

        return first;
      }),
    );
  }
}
